import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ShopTypeFilters, SpecializationTypeFilters } from '../../../../../models';
import { ToggleButtonOptions } from '../../../../common/toggle-button-group';

export const specializationTypeFilteringItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage id="ecp.filters.modal.specializationType.items.astigmatism" />
  ),
  value: SpecializationTypeFilters.astigmatism,
  testId: 'ecp-astigmatism', // Don't remove, used by YA analitics
  tooltip: <FormattedMessage id="ecp.spec.additional.astigmatism.tooltip" />,
}, {
  children: <FormattedMessage id="ecp.spec.additional.presbyopia" />,
  value: SpecializationTypeFilters.presbyopia,
  testId: 'ecp-presbyopia', // Don't remove, used by YA analitics
  tooltip: <FormattedMessage id="ecp.spec.additional.presbyopia.tooltip" />,
}];

export const specFilterItemsWithMyopia: ToggleButtonOptions[] = [
  ...specializationTypeFilteringItems,
  {
    children: (
      <FormattedMessage id="ecp.spec.additional.myopia_control" />
    ),
    value: SpecializationTypeFilters.myopiaControl,
    testId: 'ecp-myopia-control', // Don't remove, used by YA analitics
    tooltip: <FormattedMessage id="ecp.spec.additional.myopia.tooltip" />,
  },
];

export const retailerShopTypeItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.optics"
    />
  ),
  value: ShopTypeFilters.optics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.clinics"
    />
  ),
  value: ShopTypeFilters.clinics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.vendings"
    />
  ),
  value: ShopTypeFilters.vendings,
}];

export const shopTypeItems: ToggleButtonOptions[] = [{
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.optics"
    />
  ),
  value: ShopTypeFilters.optics,
}, {
  children: (
    <FormattedMessage
      id="ecp.filters.modal.shopType.items.clinics"
    />
  ),
  value: ShopTypeFilters.clinics,
}];
